import { getFileTemplate } from "../../utils/handler_files";

const getData = () => ({
  // personal data
  id: 0,
  profileImg: getFileTemplate(),
  name: "",
  lastName: "",
  email: "",
  tel: "",
  // vehicle data
  vehicleModel: "",
  vehicleYear: 0,
  vehicleABS: false,
  vehicleAirbags: 0,
  vehicleColor: "",
  vehiclePlates: "",
  vehicleEconomicNumber: "",
  vehicleFrontPhoto: getFileTemplate(),
  vehicleBackPhoto: getFileTemplate(),
  vehicleLeftPhoto: getFileTemplate(),
  vehicleRightPhoto: getFileTemplate(),
  // documents data
  ine: getFileTemplate(),
  driverLicence: getFileTemplate(),
  circulationCard: getFileTemplate(),
  contractRequest: getFileTemplate(),
  insurensePolicy: getFileTemplate(),
  criminalLetter: getFileTemplate(),
  address: getFileTemplate(),
  vehicleCardConstancy: getFileTemplate(),
});

const getErrorsData = () => ({
  // personal data
  profileImg: "",
  name: "",
  lastName: "",
  email: "",
  tel: "",
  // vehicle data
  vehicleModel: "",
  vehicleYear: "",
  vehicleABS: "",
  vehicleAirbags: "",
  vehicleColor: "",
  vehiclePlates: "",
  vehicleEconomicNumber: "",
  vehicleFrontPhoto: "",
  vehicleBackPhoto: "",
  vehicleLeftPhoto: "",
  vehicleRightPhoto: "",
  // documents data
  ine: "",
  driverLicence: "",
  circulationCard: "",
  contractRequest: "",
  insurensePolicy: "",
  criminalLetter: "",
  address: "",
  vehicleCardConstancy: "",
});

const getTestData = () => ({
  error: false,
  message: "",
});

export default {
  getData,
  getErrorsData,
  getTestData,
};
